import { DatePicker, Flex, Skeleton } from "antd";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BankBarChart from "../../Reuseable/BankBarChart/BankBarChart";
import CheckboxFilterDropdown from "../../Reuseable/CheckboxFilterDropdown/CheckboxFilterDropdown";
import DateFilter from "../../Reuseable/DateFilter/DateFilter";
import DonutChartSkeleton from "../../Reuseable/DonutChart/DonutChartSkeleton/DonutChartSkeleton";
import DonutChartWithLegend from "../../Reuseable/DonutChartWithLegend/DonutChartWithLegend";
import BarChartSkeleton from "../../Reuseable/Skeleton/BarchartSkeleton";
import { fetchAgencyProducts } from "../../store/agencySlice";
import {
  fetchBucketWiseAllocation,
  fetchBucketWiseStatus,
} from "../../store/bucketSlice";
import {
  fetchBankOverview,
  fetchCaseIntencity,
  fetchMonthlyPtp,
  fetchWeeklyPaid,
} from "../../store/portfolioSlice";
import "./BankDashboardComp.scss";
import dayjs from "dayjs";

import BucketStatusTable from "./BucketStatusTable/BucketStatusTable";
import BucketwiseTable from "./BucketwiseTable/BucketwiseTable";
import {
  fetchTelecallerBankreportStats,
  fetchTelecallerBankTeamleadOverview,
  fetchTelecallerBucketWiseAllocation,
  fetchTelecallerBucketWiseStatus,
} from "../../store/telecaller/bankDashboard";
import {
  formatCurrency,
  formatWithCommas,
  getUserType,
} from "../../assets/helpers";
import StatsCard from "../../Reuseable/StatsCard/StatsCard";
import IntensityCards from "./IntensityCards/IntensityCards";
import BarChart from "../../Reuseable/Barchart/Barchart";
import StackedBarChart from "../../Reuseable/StackedBar/StackedBarChart";
import { ReactComponent as Calender } from "../../assets/Icons/calendarIcon.svg";
import CustomSelect from "../../Reuseable/Select/Select";
import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import { fetchTeleCallers } from "../../store/userRoleSlice";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { downloadMontlyReport } from "../../assets/api/portfolio";
import toast from "react-hot-toast";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";

const BankDashboardComp = () => {
  const {
    bankOverview,
    bankOverviwLoading,
    case_intensity_counts,
    case_intensity_counts_loading,
    Monthly_ptp,
    Monthly_ptp_loading,
    Weekly_paid,
    Weekly_paid_loading,
  } = useSelector((state) => state?.portfolio);
  const { products_list, products_loading } = useSelector(
    (state) => state?.agency,
  );
  const { token } = useSelector((state) => state?.auth);
  const { telecallers, telecallers_loading } = useSelector(
    (state) => state?.userRoles,
  );
  const {
    bucketwise_allocation,
    bucketwise_loading,
    bucketwise_status_loading,
    bucketwise_status,
  } = useSelector((state) => state?.bucketwise);
  const { format } = useSelector((state) => state.priceFormat);
  const {
    telecaller_bucketwise_allocation,
    telecaller_bucketwise_allocation_loading,
    telecaller_bucketwise_status_loading,
    telecaller_bucketwise_status,
    telecaller_bank_teamlead_overview_loading,
    telecaller_bank_teamlead_overview,
    telecaller_bankreport_stats,
    telecaller_bankreport_stats_loading,
  } = useSelector((state) => state.telecallerBankDashboard);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({});

  useEffect(() => {
    dispatch(fetchBucketWiseAllocation({ portfolio_id: id }));
    dispatch(fetchBucketWiseStatus({ portfolio_id: id }));
    dispatch(fetchTelecallerBucketWiseAllocation({ portfolio_id: id }));
    dispatch(fetchTelecallerBucketWiseStatus({ portfolio_id: id }));
    dispatch(fetchTelecallerBankTeamleadOverview({ portfolio_id: id }));
    dispatch(fetchTelecallerBankreportStats({ portfolio_id: id }));
    dispatch(fetchCaseIntencity({ portfolio: id }));
    if (!user?.is_tc) {
      dispatch(fetchTeleCallers());
    }
  }, [dispatch, id, user]);

  const getData = () => {
    switch (getUserType(user)) {
      case "telecaller":
        return (
          {
            data: telecaller_bank_teamlead_overview,
            loading: telecaller_bank_teamlead_overview_loading,
          } ?? null
        );
      case "supervisor":
      case "agency":
        return (
          {
            data: bankOverview,
            loading: bankOverviwLoading,
          } ?? null
        );
    }
  };

  const getAllocationData = () => {
    if (user?.is_tc) {
      return telecaller_bucketwise_allocation;
    } else {
      return bucketwise_allocation;
    }
  };
  const getStatusData = () => {
    if (user?.is_tc) {
      return telecaller_bucketwise_status;
    } else {
      return bucketwise_status;
    }
  };

  const categoriesData = useMemo(
    () => getData()?.data?.bar_chart?.map((item) => item?.date),
    [getData()],
  );

  const seriesData2 = useMemo(
    () => [
      {
        name: "Total ODPOS",
        data: getData()?.data?.bar_chart?.map((item) => item?.total_odpos ?? 0),
      },
      {
        name: "Resolved",
        data: getData()?.data?.bar_chart?.map(
          (item) => item?.resolved_odpos ?? 0,
        ),
      },
    ],
    [bankOverview, telecaller_bank_teamlead_overview],
  );

  const barColors = useMemo(() => ["#4CB55C", "#F7A844"], []);

  const productOptions = products_list?.results?.map((item) => ({
    label: item?.products,
    value: item?.products,
  }));

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [params, setParams] = useState({
    product: "",
    start_date: null,
    end_date: null,
  });
  const [monthlyReportParam, setMonthlyReportParam] = useState({});

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const handleDateChange = (from, to) => {
    setFromDate(from);
    setToDate(to);

    // Handle clear case
    if (!from || !to) {
      setParams((prev) => ({
        ...prev,
        start_date: null,
        end_date: null,
      }));
      return;
    }

    setParams((prev) => ({
      ...prev,
      start_date: dayjs(from).format("DD-MM-YYYY"),
      end_date: dayjs(to).format("DD-MM-YYYY"),
    }));
  };

  const handleProductChange = useCallback((products) => {
    setSelectedProducts(products);
  }, []);

  useEffect(() => {
    dispatch(fetchAgencyProducts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchBankOverview({ bank_id: id, ...params }));
  }, [dispatch, id, params]);

  useEffect(() => {
    dispatch(fetchMonthlyPtp({ portfolio: id }));
    dispatch(fetchWeeklyPaid({ portfolio: id }));
  }, [dispatch, id]);

  const handleApplyMonthlyPtpFilter = () => {
    dispatch(fetchMonthlyPtp({ portfolio: id, ...monthlyReportParam }));
  };
  const handleExportMonthlyPtp = async () => {
    setLoading(true);
    try {
      const res = await downloadMontlyReport(token, {
        portfolio: id,
        export: true,
        ...monthlyReportParam,
      });
      if (res?.status === 200) {
        const url = res?.data?.data?.download_url;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Monthly_PTP_Report_${id}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(res?.message || "Failed to export report");
      }
    } catch (error) {
      setLoading(false);
    }
  };
  console.log(loading, "lksdkjflfkdjfkldjklf");

  const handleApplyFilter = (products) => {
    setParams((prev) => ({
      ...prev,
      products,
    }));
  };

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // console.log(Monthly_ptp?.callers,'lkjdflkdjflkdjf');

  const tableData = useMemo(() => {
    if (!Monthly_ptp?.callers) return [];

    return Object.entries(Monthly_ptp.callers).map(([name, stats]) => ({
      key: name,
      telecaller: name,
      ...(stats || {}),
    }));
  }, [Monthly_ptp?.callers]);

  const weeklyPaidTableData = useMemo(() => {
    if (!Weekly_paid?.callers) return [];

    return Object.entries(Weekly_paid.callers).map(([name, stats]) => ({
      key: name,
      telecaller: name,
      ...(stats || {}),
    }));
  }, [Weekly_paid?.callers]);

  const columns = [
    {
      title: "Telecaller",
      dataIndex: "telecaller",
      key: "telecaller",
      fixed: "left",
      width: 150,
      render: (val) =>
        Monthly_ptp_loading ? <Skeleton.Input size="small" active /> : val,
    },
    {
      title: "Past Weeks Count",
      dataIndex: "total_past_weeks",
      key: "total",
      render: (value) =>
        Monthly_ptp_loading ? (
          <Skeleton.Input size="small" active />
        ) : value ? (
          `${formatWithCommas(value.ptp_amount)}`
        ) : (
          "-"
        ),
    },

    ...days.map((day) => ({
      title: day,
      dataIndex: day,
      key: day,
      render: (value) =>
        Monthly_ptp_loading ? (
          <Skeleton.Input size="small" active />
        ) : value ? (
          `${formatWithCommas(value.ptp_amount)}`
        ) : (
          "-"
        ),
    })),
  ];
  const columns2 = [
    {
      title: "Telecaller",
      dataIndex: "telecaller",
      key: "telecaller",
      fixed: "left",
      width: 150,
      render: (val) =>
        Weekly_paid_loading ? <Skeleton.Input size="small" active /> : val,
    },
    {
      title: "Past Weeks Count",
      dataIndex: "total_past_weeks",
      key: "total",
      render: (value) =>
        Weekly_paid_loading ? (
          <Skeleton.Input size="small" active />
        ) : value ? (
          `${formatWithCommas(value.paid_amount)}`
        ) : (
          "-"
        ),
    },

    ...days.map((day) => ({
      title: day,
      dataIndex: day,
      key: day,
      render: (value) =>
        Weekly_paid_loading ? (
          <Skeleton.Input size="small" active />
        ) : value ? (
          `${formatWithCommas(value.paid_amount)}`
        ) : (
          "-"
        ),
    })),
  ];

  const onWeekPTPChange = (date) => {
    if (date) {
      dispatch(
        fetchMonthlyPtp({
          portfolio: id,
          week: dayjs(date).week(),
          year: dayjs(date).year(),
        }),
      );
    }
    if (!date) {
      dispatch(
        fetchMonthlyPtp({
          portfolio: id,
          // week: dayjs(date).week(),
          // year: dayjs(date).year()
        }),
      );
    }
  };
  const onWeekPaidChange = (date) => {
    if (date) {
      dispatch(
        fetchWeeklyPaid({
          portfolio: id,
          week: dayjs(date).week(),
          year: dayjs(date).year(),
        }),
      );
    }
    if (!date) {
      dispatch(
        fetchWeeklyPaid({
          portfolio: id,
          // week: dayjs(date).week(),
          // year: dayjs(date).year()
        }),
      );
    }
  };

  return (
    <Flex className="bankDashboardCompMain">
      {user?.is_tc && (
        <div
          className="statsCardContainer"
          style={{ display: "flex", width: "100%" }}
        >
          <StatsCard
            {...{
              title: "Total Allocated",
              value: telecaller_bankreport_stats?.total_allocated,
              // percent: 0,
              // type: "default",
              loading: telecaller_bankreport_stats_loading,
              info1: "Total Allocated",
              info2: false,
              type: "graph",
              chart: [
                {
                  name: "Total Allocated",
                  value: telecaller_bankreport_stats?.total_allocated,
                },
              ],
            }}
          />
          <StatsCard
            {...{
              title: "Telecaller & Field Agent",
              value: telecaller_bankreport_stats?.telecaller_percent,
              type: "graph",
              chart: [
                {
                  name: "Telecaller Percentage",
                  value: telecaller_bankreport_stats?.telecaller_percent,
                },
                {
                  name: "Field Agent Percentage",
                  value: telecaller_bankreport_stats?.field_agent_percent,
                },
              ],
              loading: telecaller_bankreport_stats_loading,
              info1: "Telecaller",
              info2: "Field Agent",
            }}
          />

          <StatsCard
            {...{
              title: "Emi Overdue",
              value: formatCurrency(
                telecaller_bankreport_stats?.emi_overdue,
                format,
              ),

              type: "graph",
              loading: telecaller_bankreport_stats_loading,
              chart: [
                {
                  name: "Emi Overdue",
                  value: telecaller_bankreport_stats?.emi_overdue,
                },
                {
                  name: "Emi Collected",
                  value: telecaller_bankreport_stats?.emi_overdue,
                },
              ],
            }}
          />
        </div>
      )}
      <div className="intensity-counts-wrapper">
        <p className="heading">Intensity Counts</p>
        {(user?.is_tc || user?.is_agency || user?.is_supervisor) && (
          <IntensityCards
            id={id}
            data={case_intensity_counts?.intensity || []}
            loading={case_intensity_counts_loading}
          />
        )}
      </div>
      <div className="monthly-ptp-chart-wrapper">
        <div className="heading recovery-pending-heading">
          <h2>Weekly PTP</h2>
          <DatePicker
            picker="week"
            format="YYYY-ww" // ✅ use lowercase ww
            onChange={onWeekPTPChange}
          />
        </div>
        <ReusableTable
          columns={columns}
          dataSource={Monthly_ptp_loading ? Array(5).fill({}) : tableData}
        />
      </div>
      <div className="monthly-ptp-chart-wrapper">
        <div className="heading recovery-pending-heading">
          <h2>Weekly Paid</h2>
          <DatePicker
            picker="week"
            format="YYYY-ww"
            onChange={onWeekPaidChange}
          />
        </div>
        <ReusableTable
          columns={columns2}
          dataSource={
            Weekly_paid_loading ? Array(5).fill({}) : weeklyPaidTableData
          }
        />
      </div>

      <p className="heading">Chart</p>
      <Flex className="bankDashboard-charts">
        {getData()?.loading ? (
          <BarChartSkeleton className={"barChartLoader"} />
        ) : (
          <BankBarChart
            categories={categoriesData}
            seriesData={seriesData2}
            barColors={barColors}
            height={300}
          />
        )}
        {user?.is_tc ? (
          <></>
        ) : (
          <Flex className="details-container-graph">
            <Flex className="graphs-header">
              <p className="heading-2">Teamlead Report Overview</p>
              <Flex className="graph-filter">
                <CheckboxFilterDropdown
                  label="Products"
                  options={productOptions}
                  selected={selectedProducts}
                  onChange={handleProductChange}
                  handleApplyFilter={handleApplyFilter}
                />

                <DateFilter onDateChange={handleDateChange} />
              </Flex>

              <Flex></Flex>
            </Flex>
            <Flex className="donuts-chart-wrapper">
              <Flex className="donuts-chart">
                {bankOverviwLoading ? (
                  <DonutChartSkeleton segments={3} />
                ) : (
                  <DonutChartWithLegend
                    data={[
                      {
                        name: "Total Allocated",
                        value: bankOverview?.donut_chart?.total_allocated || 0,
                      },
                      {
                        name: "EMI Overdue",
                        value:
                          Number(
                            bankOverview?.donut_chart?.emi_overdue,
                          ).toFixed(2) || 0,
                      },
                      {
                        name: "EMI Collected",
                        value: bankOverview?.donut_chart?.emi_collected || 0,
                      },
                    ]}
                    colors={[
                      "#F7A844",
                      "rgba(247, 168, 68, 0.50)",
                      "rgba(247, 168, 68, 0.20)",
                    ]}
                  />
                )}
              </Flex>

              {bankOverviwLoading ? (
                <DonutChartSkeleton segments={3} />
              ) : (
                <DonutChartWithLegend
                  data={[
                    {
                      name: "Telecaller",
                      value: bankOverview?.donut_chart?.telecaller_percent,
                    },
                    {
                      name: "Field Agent",
                      value: bankOverview?.donut_chart?.field_agent_percent,
                    },
                  ]}
                  colors={["#4CB55C", "rgba(76, 181, 92, 0.50)"]}
                  isPercentage={true}
                />
              )}
            </Flex>
          </Flex>
        )}
        {/* </Flex>  */}
      </Flex>
      <p className="heading">Bucketwise Allocation</p>
      <Flex className="bucketwise-allocation-table">
        <BucketwiseTable
          data={getAllocationData()?.data || []}
          loading={
            bucketwise_loading || telecaller_bucketwise_allocation_loading
          }
          id={id}
        />
      </Flex>
      <p className="heading">Bucket Status</p>
      <Flex className="bucket-status-table">
        <BucketStatusTable
          data={getStatusData()?.classification_data}
          loading={
            bucketwise_status_loading || telecaller_bucketwise_status_loading
          }
        />
      </Flex>
    </Flex>
  );
};
export default BankDashboardComp;
